module.exports = __webpack_public_path__ + "static/video3-2bbc1533d47399e48b0c2431b95a91d8.png";